module.exports = __webpack_public_path__ + "static/media/notebook.b8649bec.png";